<template lang="html">
	<router-view />
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// index.vue?5d3aa60a